import { DEMO_ACADEMY_NORTH_ID, DEMO_ACADEMY_SOUTH_ID } from "./mockFilterHelpers";
import { DEMO_ACADEMY_ID, mockPlayers } from "./mockPlayers";
import { mockTrainers } from "./mockTrainers";
import { demoAcademyLogo, demoAvatarPhoto, demoConversationLogo } from "./demoImages";
import { demoApi } from "./demoLocale";

type ChatMessage = {
  Id: string;
  Content: string;
  Type: number;
  ActionType: number;
  IsDelete: boolean;
  From: string;
  Sender: {
    Id: string;
    Name: string;
    PhotoFilePath: string;
  };
  Files: null;
  Reply: null;
};

type ChatConversation = {
  Id: string;
  AcademyId: string;
  Name: string;
  Type: number;
  LogoFilePath: string;
  IsClosed: boolean;
  IsForAdultOnly: boolean;
  Members: Array<{ Id: string; Name: string; IsOnline?: boolean }>;
  LastMessage: {
    Content: string;
    Sent: string;
  };
  Messages: ChatMessage[];
  PrivateProfileId?: string;
  PrivateProfileType?: number;
};

const academySender = (academyId: string, academyName: string) => ({
  Id: academyId,
  Name: academyName,
  PhotoFilePath: demoAcademyLogo(academyName),
});

const profileSender = (id: string, name: string) => ({
  Id: id,
  Name: name,
  PhotoFilePath: demoAvatarPhoto(id),
});

const minutesAgo = (minutes: number) => new Date(Date.now() - minutes * 60_000).toISOString();

const buildMessage = (
  id: string,
  content: string,
  sender: { Id: string; Name: string; PhotoFilePath?: string }
): ChatMessage => ({
  Id: id,
  Content: content,
  Type: 0,
  ActionType: 0,
  IsDelete: false,
  From: sender.Id,
  Sender: {
    Id: sender.Id,
    Name: sender.Name,
    PhotoFilePath: sender.PhotoFilePath ?? "",
  },
  Files: null,
  Reply: null,
});

const jan = mockPlayers[0];
const adam = mockPlayers[1];
const piotr = mockPlayers[2];
const marek = mockTrainers[0];
const tomasz = mockTrainers[1];

const mainAcademy = { id: DEMO_ACADEMY_ID, name: "Klub piłkarski" };
const northAcademy = { id: DEMO_ACADEMY_NORTH_ID, name: "Oddział Akademii" };
const southAcademy = { id: DEMO_ACADEMY_SOUTH_ID, name: "Oddział Akademii - Zachodni" };

const demoConversationsSource: ChatConversation[] = [
  {
    Id: "00000000-0000-0000-0000-00000000c101",
    AcademyId: mainAcademy.id,
    Name: marek.Name,
    Type: 0,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    PrivateProfileId: marek.TrainerId,
    PrivateProfileType: 2,
    Members: [{ Id: marek.TrainerId, Name: marek.Name, IsOnline: true }],
    LastMessage: {
      Content: "Jutrzejszy trening przenosimy na 11:00, proszę o info zwrotne.",
      Sent: minutesAgo(18),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m101",
        "Dzień dobry, czy mogę dostać listę obecności z ostatniego meczu?",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m102",
        "Oczywiście, wyślę po treningu. Wszyscy z U15A byli na boisku.",
        profileSender(marek.TrainerId, marek.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m103",
        "Super, dziękuję. Rodzice pytali też o obóz letni.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m104",
        "Materiały wyślę dziś wieczorem. Zapisy do piątku.",
        profileSender(marek.TrainerId, marek.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m105",
        "Jutrzejszy trening przenosimy na 11:00, proszę o info zwrotne.",
        profileSender(marek.TrainerId, marek.Name)
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c102",
    AcademyId: mainAcademy.id,
    Name: jan.Name,
    Type: 0,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    PrivateProfileId: jan.PlayerId,
    PrivateProfileType: 1,
    Members: [{ Id: jan.PlayerId, Name: jan.Name, IsOnline: false }],
    LastMessage: {
      Content: "Rodzic potwierdził obecność na zajęciach w środę.",
      Sent: minutesAgo(95),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m201",
        "Cześć, Jan nie dotrze dziś na trening — kontuzja kostki.",
        profileSender(jan.PlayerId, jan.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m202",
        "Dzięki za informację. Niech odpoczywa, wrócimy do kontaktu za tydzień.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m203",
        "Rodzic potwierdził obecność na zajęciach w środę.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c103",
    AcademyId: mainAcademy.id,
    Name: "Rodzic — Adam Nowak",
    Type: 0,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    PrivateProfileId: adam.PlayerId,
    PrivateProfileType: 1,
    Members: [{ Id: adam.PlayerId, Name: adam.Name, IsOnline: true }],
    LastMessage: {
      Content: "Czy po obserwacji dostaniemy informację o dalszych krokach?",
      Sent: minutesAgo(240),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m301",
        "Dzień dobry, Adam bardzo zmotywowany po ostatnich zajęciach próbnych.",
        profileSender(adam.PlayerId, "Rodzic — Adam Nowak")
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m302",
        "To świetnie! Skaut przygotuje krótką notatkę po kolejnym treningu.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m303",
        "Czy po obserwacji dostaniemy informację o dalszych krokach?",
        profileSender(adam.PlayerId, "Rodzic — Adam Nowak")
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c201",
    AcademyId: mainAcademy.id,
    Name: "Pierwsza drużyna — rodzice",
    Type: 1,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    Members: [
      { Id: jan.PlayerId, Name: jan.Name, IsOnline: false },
      { Id: piotr.PlayerId, Name: piotr.Name, IsOnline: true },
      { Id: marek.TrainerId, Name: marek.Name, IsOnline: true },
    ],
    LastMessage: {
      Content: "Piotr: Pamiętajcie o białych koszulkach na turniej!",
      Sent: minutesAgo(42),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m401",
        "Witam wszystkich, wrzucam plan wyjazdu na turniej w Gdańsku.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m402",
        "O której zbiórka w sobotę?",
        profileSender(jan.PlayerId, "Rodzic — Jan K.")
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m403",
        "Zbiórka o 7:30 przy akademii. Proszę być 10 min wcześniej.",
        profileSender(marek.TrainerId, marek.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m404",
        "Pamiętajcie o białych koszulkach na turniej!",
        profileSender(piotr.PlayerId, piotr.Name)
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c202",
    AcademyId: mainAcademy.id,
    Name: "Kadra trenerska",
    Type: 1,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: true,
    Members: [
      { Id: marek.TrainerId, Name: marek.Name, IsOnline: true },
      { Id: tomasz.TrainerId, Name: tomasz.Name, IsOnline: false },
    ],
    LastMessage: {
      Content: "Tomasz: Materiały do microcycle 12 są już w folderze.",
      Sent: minutesAgo(12),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m501",
        "Cześć, kto prowadzi analizę meczu w czwartek?",
        profileSender(marek.TrainerId, marek.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m502",
        "Ja biorę U13B, możemy się wymienić nagraniami.",
        profileSender(tomasz.TrainerId, tomasz.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m503",
        "Materiały do microcycle 12 są już w folderze.",
        profileSender(tomasz.TrainerId, tomasz.Name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m504",
        "Dzięki, wrzucę też plan regeneracji po meczu.",
        academySender(mainAcademy.id, mainAcademy.name)
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c301",
    AcademyId: northAcademy.id,
    Name: "Trampkarz 2014 — info",
    Type: 1,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    Members: [
      { Id: mockPlayers[3].PlayerId, Name: mockPlayers[3].Name, IsOnline: true },
      { Id: mockTrainers[3].TrainerId, Name: mockTrainers[3].Name, IsOnline: true },
    ],
    LastMessage: {
      Content: "Trening wtorek przeniesiony na halę przy ul. Sportowej 8.",
      Sent: minutesAgo(360),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m601",
        "Przypominam o zebraniu rodziców w poniedziałek o 18:00.",
        academySender(northAcademy.id, northAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m602",
        "Trening wtorek przeniesiony na halę przy ul. Sportowej 8.",
        profileSender(mockTrainers[3].TrainerId, mockTrainers[3].Name)
      ),
    ],
  },
  {
    Id: "00000000-0000-0000-0000-00000000c401",
    AcademyId: southAcademy.id,
    Name: tomasz.Name,
    Type: 0,
    LogoFilePath: "",
    IsClosed: false,
    IsForAdultOnly: false,
    PrivateProfileId: tomasz.TrainerId,
    PrivateProfileType: 2,
    Members: [{ Id: tomasz.TrainerId, Name: tomasz.Name, IsOnline: false }],
    LastMessage: {
      Content: "Lista zawodników na sparing jest już zatwierdzona.",
      Sent: minutesAgo(55),
    },
    Messages: [
      buildMessage(
        "00000000-0000-0000-0000-00000000m701",
        "Czy możemy dodać jednego zawodnika z grupy Młodzik 2013 na sparing?",
        academySender(southAcademy.id, southAcademy.name)
      ),
      buildMessage(
        "00000000-0000-0000-0000-00000000m702",
        "Lista zawodników na sparing jest już zatwierdzona.",
        profileSender(tomasz.TrainerId, tomasz.Name)
      ),
    ],
  },
];

const getAcademyNameById = (academyId: string) => {
  if (academyId === northAcademy.id) {
    return northAcademy.name;
  }
  if (academyId === southAcademy.id) {
    return southAcademy.name;
  }
  return mainAcademy.name;
};

const demoConversations: ChatConversation[] = demoConversationsSource.map((conversation) => ({
  ...conversation,
  LogoFilePath: demoConversationLogo({
    type: conversation.Type,
    name: conversation.Name,
    privateProfileId: conversation.PrivateProfileId,
    academyName: conversation.Type === 1 ? undefined : getAcademyNameById(conversation.AcademyId),
  }),
}));

const filterByAcademy = (academyId?: string) =>
  demoConversations.filter(
    (conversation) => conversation.AcademyId === (academyId ?? DEMO_ACADEMY_ID)
  );

const filterBySearch = (items: ChatConversation[], searchQuery?: string) => {
  const query = searchQuery?.trim().toLowerCase();
  if (!query) {
    return items;
  }
  return items.filter(
    (conversation) =>
      conversation.Name.toLowerCase().includes(query) ||
      conversation.LastMessage.Content.toLowerCase().includes(query)
  );
};

export const getMockChatConversations = demoApi(async (academyId?: string, searchQuery?: string) => {
  const items = filterBySearch(filterByAcademy(academyId), searchQuery).map(
    ({
      Messages: _messages,
      PrivateProfileId: _p,
      PrivateProfileType: _t,
      AcademyId: _a,
      ...rest
    }) => rest
  );

  return {
    Items: items,
    TotalCount: items.length,
  };
});

export const getMockChatMessages = demoApi(async (conversationId?: string) => {
  const conversation = demoConversations.find((item) => item.Id === conversationId);
  return {
    Items: conversation?.Messages ?? [],
    TotalCount: conversation?.Messages.length ?? 0,
  };
});

export const getMockPrivateConversationById = demoApi(async (
  academyId?: string,
  profileId?: string,
  profileType?: number
) => {
  const conversation = demoConversations.find(
    (item) =>
      item.AcademyId === academyId &&
      item.Type === 0 &&
      item.PrivateProfileId === profileId &&
      item.PrivateProfileType === profileType
  );

  if (!conversation) {
    return null;
  }

  return {
    ConversationId: conversation.Id,
    Name: conversation.Name,
    LogoFilePath: conversation.LogoFilePath,
  };
});

export const getMockGroupConversationById = demoApi(async (folderId?: string) => {
  const conversation = demoConversations.find(
    (item) => item.Type === 1 && item.Id.endsWith(folderId?.slice(-3) ?? "___")
  );

  if (!conversation) {
    return null;
  }

  return {
    ConversationId: conversation.Id,
    Name: conversation.Name,
    LogoFilePath: conversation.LogoFilePath,
  };
});

export const getMockConversationMembers = demoApi(async (_academyId?: string, conversationId?: string) => {
  const conversation = demoConversations.find((item) => item.Id === conversationId);
  return {
    Items:
      conversation?.Members.map((member) => ({
        Id: member.Id,
        Name: member.Name,
        PhotoFilePath: demoAvatarPhoto(member.Id),
        ProfileType:
          member.Id === conversation.PrivateProfileId ? conversation.PrivateProfileType ?? 1 : 1,
      })) ?? [],
    TotalCount: conversation?.Members.length ?? 0,
  };
});

export const getMockOnlineProfiles = demoApi(async () => {
  const profiles = demoConversations.flatMap((conversation) => conversation.Members);
  const unique = new Map(profiles.map((profile) => [profile.Id, profile]));

  return {
    Items: Array.from(unique.values()).map((profile) => ({
      Id: profile.Id,
      IsOnline: profile.IsOnline ?? false,
    })),
    TotalCount: unique.size,
  };
});

export const getMockUnreadMessagesCount = demoApi(async () => 4);
